import { areaData } from "../../Types/Types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAreas } from "../middleware/areaMiddleware";

interface areaDataState {
  loading: boolean;
  error: string | null;
  dataArea: areaData[] | null;
}

const initialState: areaDataState = {
  loading: false,
  error: null,
  dataArea: null,
};

const postSlice = createSlice({
  name: "area",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getAreas.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getAreas.fulfilled,
        (state, action: PayloadAction<areaData[]>) => {
          state.loading = false;
          state.dataArea = action.payload;
        }
      )
      .addCase(getAreas.rejected, (state, action: PayloadAction<any>) => {
        state.error = action.payload;
      });
  },
});

export default postSlice.reducer;
